import { Component, OnInit, ViewChild, ElementRef, Input, EventEmitter, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

// npm install --save-dev @types/stripe-v3
declare let Stripe;//: stripe.StripeStatic;

@Component({
  selector: 'app-elements',
  templateUrl: './elements.component.html',
  styleUrls: ['./elements.component.scss']
})
export class ElementsComponent implements OnInit {

  @Output() result = new EventEmitter(); 
  // @Input() emit: string;
  // @Input() func: string;
  // @Input() call: string;
  // @Input() doc: string;
  // @Input() col: string;
  // @Input() get: string;
  // @Input() color: string = 'danger';

  constructor(
  ) {
  }

  @Input() amount: number;
  @Input() description: string;
  @ViewChild('cardElement', {static:true}) cardElement: ElementRef;

  stripe; // : stripe.Stripe;
  card;
  cardErrors;

  loading = false;
  confirmation;
  primary = true;

  test:any = false;
  // charge;
  // token;
  // source;










  ngOnInit() {
    this.test = !environment.production;
    this.stripe = Stripe(environment.stripe);
    const elements = this.stripe.elements();

    this.card = elements.create('card', {style: this.style});
    this.card.mount(this.cardElement.nativeElement);

    this.card.addEventListener('change', ({ error }) => {
        this.cardErrors = error && error.message;
    });
  }









  
  async handleForm(e?) {
    // e.preventDefault();
    this.loading = true;

    const { source, error } = await this.stripe.createSource(this.card);

    if (error) {
      // Inform the customer that there was an error.
      this.cardErrors = error.message;
      this.loading = false;
    } else {
      // Send the token to your server.
      // this[this.get || 'confirmation'] = (this.func && this[this.func])? await this[this.func](source):source;
      this.loading = false;
      this.result.emit({source: source, primary: this.primary, amount: this.amount});
    }
  }






  
  style: any = {
    base: {
      color: '#303238',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      '::placeholder': {
        color: '#CFD7DF',
      },
      border: '1px solid #e5e5e5'
    },
    invalid: {
      color: '#e5424d',
      ':focus': {
        color: '#303238',
      },
    },
  };

}